//import api from '../api';
import { newAPIPost } from '../api/index.js';
import dateFormat from '../utils/dateFormat';

export default {
    state: {
        gstStage: [],
        searchRequest: null,
      },

      mutations: {
        updateGSTStage(state, list) {
          state.gstStage = list;
        },
        updateSearchGSTStageRequest(state, searchRequest) {
          state.searchRequest = searchRequest;
        },
      },


      actions: {
        async gstStage({ commit, state }, request) {
          const fallbackRequest = request || state.searchRequest;
          const requestToSend = JSON.parse(JSON.stringify(fallbackRequest));

         
          // if (requestToSend.deliveryStartDate.endDate) {
          //   requestToSend.deliveryStartDate.endDate = moment(requestToSend.deliveryStartDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.deliveryStartDate.startDate && !requestToSend.deliveryStartDate.endDate) {
          //   requestToSend.deliveryStartDate.endDate = moment(requestToSend.deliveryStartDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          // if (requestToSend.deliveryEndDate.endDate) {
          //   requestToSend.deliveryEndDate.endDate = moment(requestToSend.deliveryEndDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.deliveryEndDate.startDate && !requestToSend.deliveryEndDate.endDate) {
          //   requestToSend.deliveryEndDate.endDate = moment(requestToSend.deliveryEndDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          // if (requestToSend.ArrivalDate.endDate) {
          //   requestToSend.ArrivalDate.endDate = moment(requestToSend.ArrivalDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.ArrivalDate.startDate && !requestToSend.ArrivalDate.endDate) {
          //   requestToSend.ArrivalDate.endDate = moment(requestToSend.ArrivalDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          // if (requestToSend.LeaveDate.endDate) {
          //   requestToSend.LeaveDate.endDate = moment(requestToSend.LeaveDate.endDate)
          //     .endOf('d')
          //     .toDate();
          // }
        
          // if (requestToSend.LeaveDate.startDate && !requestToSend.LeaveDate.endDate) {
          //   requestToSend.LeaveDate.endDate = moment(requestToSend.LeaveDate.startDate)
          //     .endOf('d')
          //     .toDate();
          // }


          if (requestToSend.confirmDate.endDate) {
            requestToSend.confirmDate.endDate = moment(requestToSend.confirmDate.endDate)
              .endOf('d')
              .toDate();
          }
        
          if (requestToSend.confirmDate.startDate && !requestToSend.confirmDate.endDate) {
            requestToSend.confirmDate.endDate = moment(requestToSend.confirmDate.startDate)
              .endOf('d')
              .toDate();
          }


          if (requestToSend.changeDate.endDate) {
            requestToSend.changeDate.endDate = moment(requestToSend.changeDate.endDate)
              .endOf('d')
              .toDate();
          }
        
          if (requestToSend.changeDate.startDate && !requestToSend.changeDate.endDate) {
            requestToSend.changeDate.endDate = moment(requestToSend.changeDate.startDate)
              .endOf('d')
              .toDate();
          }


          if (requestToSend.deliveryStartDate.startDate)
          {
            requestToSend.deliveryStartDate.startDate = dateFormat.getLocalDate(requestToSend.deliveryStartDate.startDate);
          }

          if (requestToSend.deliveryStartDate.endDate)
          {
            requestToSend.deliveryStartDate.endDate = dateFormat.getLocalDateEnd(requestToSend.deliveryStartDate.endDate);
          }
          else
          {
            requestToSend.deliveryStartDate.endDate = dateFormat.getLocalDateEnd(requestToSend.deliveryStartDate.startDate);
          }


          if (requestToSend.deliveryEndDate.startDate)
          {
            requestToSend.deliveryEndDate.startDate = dateFormat.getLocalDate(requestToSend.deliveryEndDate.startDate);
          }

          if (requestToSend.deliveryEndDate.endDate)
          {
            requestToSend.deliveryEndDate.endDate = dateFormat.getLocalDateEnd(requestToSend.deliveryEndDate.endDate);
          }
          else
          {
            requestToSend.deliveryEndDate.endDate = dateFormat.getLocalDateEnd(requestToSend.deliveryEndDate.startDate);
          }

          if (requestToSend.arrivalDate.startDate)
          {
            requestToSend.arrivalDate.startDate = dateFormat.getLocalDate(requestToSend.arrivalDate.startDate);
          }

          if (requestToSend.arrivalDate.endDate)
          {
            requestToSend.arrivalDate.endDate = dateFormat.getLocalDateEnd(requestToSend.arrivalDate.endDate);
          }
          else
          {
            requestToSend.arrivalDate.endDate = dateFormat.getLocalDateEnd(requestToSend.arrivalDate.startDate);
          }

          if (requestToSend.leaveDate.startDate)
          {
            requestToSend.leaveDate.startDate = dateFormat.getLocalDate(requestToSend.leaveDate.startDate);
          }

          if (requestToSend.leaveDate.endDate)
          {
            requestToSend.leaveDate.endDate = dateFormat.getLocalDateEnd(requestToSend.leaveDate.endDate);
          }
          else
          {
            requestToSend.leaveDate.endDate = dateFormat.getLocalDateEnd(requestToSend.leaveDate.startDate);
          }

          // if (requestToSend.ConfirmDate.startDate)
          // {
          //   requestToSend.ConfirmDate.startDate = dateFormat.getLocalDate(requestToSend.ConfirmDate.startDate);
          // }

          // if (requestToSend.ConfirmDate.endDate)
          // {
          //   requestToSend.ConfirmDate.endDate = dateFormat.getLocalDateEnd(requestToSend.ConfirmDate.endDate);
          // }
          // else
          // {
          //   requestToSend.ConfirmDate.endDate = dateFormat.getLocalDateEnd(requestToSend.ConfirmDate.startDate);
          // }


          // if (requestToSend.ChangeDate.startDate)
          // {
          //   requestToSend.ChangeDate.startDate = dateFormat.getLocalDate(requestToSend.ChangeDate.startDate);
          // }

          // if (requestToSend.ChangeDate.endDate)
          // {
          //   requestToSend.ChangeDate.endDate = dateFormat.getLocalDateEnd(requestToSend.ChangeDate.endDate);
          // }
          // else
          // {
          //   requestToSend.ChangeDate.endDate = dateFormat.getLocalDateEnd(requestToSend.ChangeDate.startDate);
          // }



          var reqStart = null;
          var reqEnd = null;
          if (requestToSend.deliveryStartDate.startDate != null){
            reqStart = requestToSend.deliveryStartDate.startDate;
            reqEnd = requestToSend.deliveryStartDate.endDate;
          }

          if (requestToSend.deliveryEndDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.deliveryEndDate.startDate;
              reqEnd = requestToSend.deliveryEndDate.endDate;
            }
            else
            {
              if (requestToSend.deliveryEndDate.startDate < reqStart )
              {
                reqStart = requestToSend.deliveryEndDate.startDate
              }

              if (requestToSend.deliveryEndDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.deliveryEndDate.endDate
              }


            }
            
          }

          if (requestToSend.arrivalDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.arrivalDate.startDate;
              reqEnd = requestToSend.arrivalDate.endDate;
            }
            else
            {
              if (requestToSend.arrivalDate.startDate < reqStart)
              {
                reqStart = requestToSend.arrivalDate.startDate
              }

              if (requestToSend.arrivalDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.arrivalDate.endDate
              }


            }
            
          }


          if (requestToSend.leaveDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.leaveDate.startDate;
              reqEnd = requestToSend.leaveDate.endDate;
            }
            else
            {
              if (requestToSend.leaveDate.startDate < reqStart)
              {
                reqStart = requestToSend.leaveDate.startDate
              }

              if (requestToSend.leaveDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.leaveDate.endDate
              }


            }
            
          }


          if (requestToSend.confirmDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.confirmDate.startDate;
              reqEnd = requestToSend.confirmDate.endDate;
            }
            else
            {
              if (requestToSend.confirmDate.startDate < reqStart)
              {
                reqStart = requestToSend.confirmDate.startDate
              }

              if (requestToSend.confirmDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.confirmDate.endDate
              }


            }
           
          }

          if (requestToSend.changeDate.startDate != null)
          {
            if (reqStart == null)
            {
              reqStart = requestToSend.changeDate.startDate;
              reqEnd = requestToSend.changeDate.endDate;
            }
            else
            {
              if (requestToSend.changeDate.startDate < reqStart)
              {
                reqStart = requestToSend.changeDate.startDate
              }

              if (requestToSend.changeDate.endDate > reqEnd )
              {
                reqEnd = requestToSend.changeDate.endDate
              }
            }
            
          }

          console.log(`req start is ${reqStart}`)
          console.log(`req end is ${reqEnd}`)
          console.log(requestToSend);

            
          requestToSend.createdAt.startDate = moment(reqStart).subtract(2, 'months');
          requestToSend.createdAt.endDate = moment(reqEnd).add(2, 'months');


          


          
       
            const st = performance.now();
            //const result = await api.post('/api/w/gstConfirm/WebSearchConfirmStages', requestToSend);
            const result = await newAPIPost('/api/w/gstConfirm/WebSearchConfirmStages', requestToSend);
            commit('updateSearchGSTStageRequest', fallbackRequest);
             console.log(JSON.stringify(result));
            return commit('updateGSTStage', result);
            
                },
      },


      getters: {
        getGSTStage: state => state.gstStage,
      },








}